module.exports = __webpack_public_path__ + "static/media/matilde-special-crown-sad.34a542a0.png";